import request from './request'

export function listWorkPlan(data) {
  return request.post('/production/work-plans/list', data)
}
export function getWorkPlan(id) {
  return request.get('/production/work-plans/' + id)
}
export function saveWorkPlan(data) {
  return request.post('/production/work-plans', data)
}
export function updateWorkPlan(data) {
  return request.post('/production/work-plans/update', data)
}
export function deleteWorkPlan(ids) {
  return request.post('/production/work-plans/delete', ids)
}
export function generateWorkPlanFromOrder(orderId) {
  return request.post('/production/work-plans/generate-from-order', { orderId })
}
export function dispatchWorkPlan(planId) {
  return request.post('/production/work-plans/dispatch', { planId })
}
